// extracted by mini-css-extract-plugin
export var dropdownButton = "_4d-0";
export var fullWidthDropdownButton = "_4d-1";
export var icon = "_4d-3";
export var iconPlaceholder = "_4d-2";
export var menuItemRow = "_4d-9";
export var separator = "_4d-e";
export var shortcutContainer = "_4d-7";
export var shortcutContainerFilled = "_4d-8";
export var shortcutIconLg = "_4d-6";
export var shortcutIconMd = "_4d-5";
export var shortcutIconSm = "_4d-4";
export var submenuChevron = "_4d-d";
export var submenuDropdown = "_4d-a";
export var submenuTriggerRow = "_4d-b";
export var submenuTriggerRowOpen = "_4d-c";